import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { Room } from '../../models/storage/room';
import { RoomLocation } from '../../models/storage/room-location';
import { RoomCustomAttrabute } from '../../models/storage/room-custom-attrabute';
import { RoomStatus } from '../../models/storage/roomStatus';

@Injectable({
  providedIn: 'root'
})
export class RoomService {

  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getRooms(includeInactive: boolean = false, cropYearIds: number = null): Observable<Room[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('includeInactive', includeInactive.toString());

    if (cropYearIds) {
      queryParameters = queryParameters.append('cropYearIds', cropYearIds.toString());
    }

    return this.httpClient.get<Room[]>(`${this.basePath}/api/rooms`,
      {
        params: queryParameters
      }
    );
  }

  public getRoomLocations(includeInactive: boolean = false): Observable<RoomLocation[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('includeInactive', includeInactive.toString());

    return this.httpClient.get<RoomLocation[]>(`${this.basePath}/api/RoomLocations`,
      {
        params: queryParameters
      }
    );
  }

  public getRoomLocation(id: number): Observable<RoomLocation> {
    return this.httpClient.get<RoomLocation>(`${this.basePath}/api/RoomLocations/${id}`);
  }

  public postRoomLocation(roomLocation: RoomLocation): Observable<Room> {
    return this.httpClient.post<RoomLocation>(`${this.basePath}/api/RoomLocations`, roomLocation);
  }

  public putRoomLocation(room: RoomLocation): Observable<RoomLocation[]> {
    return this.httpClient.put<RoomLocation[]>(`${this.basePath}/api/RoomLocations/${room.id}`, room);
  }

  public deleteRoomLocation(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/RoomLocations/${id}`);
  }

  public putRoom(room: Room): Observable<Room[]> {
    return this.httpClient.put<Room[]>(`${this.basePath}/api/rooms/${room.id}`, room);
  }

  public getRoom(id: number): Observable<Room> {
    return this.httpClient.get<Room>(`${this.basePath}/api/rooms/${id}`);
  }

  public deleteRoom(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/rooms/${id}`);
  }

  public postRoom(room: Room): Observable<Room> {
    return this.httpClient.post<Room>(`${this.basePath}/api/rooms`, room);
  }

  public getCustomAttributes(): Observable<RoomCustomAttrabute[]> {
    return this.httpClient.get<RoomCustomAttrabute[]>(`${this.basePath}/api/rooms/RoomCustomAttrabutes`);
  }

  public getRoomStatuses(): Observable<RoomStatus[]> {
    return this.httpClient.get<RoomStatus[]>(`${this.basePath}/api/rooms/roomStatuses`);
  }

}
